import { render, staticRenderFns } from "./guideOrder.vue?vue&type=template&id=0ed83020&scoped=true"
import script from "./guideOrder.vue?vue&type=script&lang=js"
export * from "./guideOrder.vue?vue&type=script&lang=js"
import style0 from "./guideOrder.vue?vue&type=style&index=0&id=0ed83020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed83020",
  null
  
)

export default component.exports